export const ADMIN_SERVICES_PATH = 'admin-services';
export const ADMIN_SERVICES_TITLE = 'Admin Services';
export const AUDITLOG_PATH = 'auditlog';
export const AUDITLOG_TITLE = 'Auditlog';

export const CODE_PRUEFUNG_PATH = 'code-pruefung';
export const CODE_PRUEFUNG_TITLE = 'Codeprüfung / Buchen';
export const CMS_CONTENT_PATH = 'cms-content';
export const DEMO_PATH = 'demo';
export const DEMO_TITLE = 'Demo';
export const DIENSTLEISTUNG_PATH = 'dienstleistung';
export const DIENSTLEISTUNG_TITLE = 'Code Eingabe';
export const DIENSTLEISTUNG_ADMIN_BEARBEITUNG_PATH = 'dienstleistung-admin-bearbeitung';
export const DIENSTLEISTUNGEN_PATH = 'dienstleistungen';
export const DIENSTLEISTUNGEN_TITLE = 'Dienstleistungen';
export const DIENSTLEISTUNG_ERFASSUNG_PATH = 'dienstleistung-erfassung';
export const DIENSTLEISTUNG_ERFASSUNG_TITLE = 'Dienstleistung Erfassung';
export const DIENSTLEISTUNG_SCHNELLABSCHLUSS_PATH = 'dienstleistungen-abschluss';
export const DIENSTLEISTUNG_SCHNELLABSCHLUSS_TITLE = 'Dienstleistung Schnellabschluss';
export const DOKUMENTE_PATH = 'dokumente';
export const DOKUMENTE_TITLE = 'Dokumente';
export const FALLPARTNERDETAIL_PATH = 'fallpartnerdetail';
export const FALLPARTNERDETAIL_TITLE = 'Falldaten';
export const KUNDEN_PATH = 'kunden';
export const KUNDEN_TITLE = 'Kunden Suche';
export const PARTNER_PATH = 'partner';
export const PARTNER_TITLE = 'Partner';
export const PASSWORT_PATH = 'passwort';
export const PROGRAMME_PATH = 'programme';
export const PROGRAMME_TITLE = 'Programme';

export const LABOR_PROTOKOLL_PATH = 'laborprotokoll';
export const LABOR_PROTOKOLL_TITLE = 'Laborprotokoll';
export const LABOR_PROTOKOLL_DETAIL_PATH = 'laborprotokolldetail';

export const LEISTUNG_PATH = 'leistung';
export const LEISTUNG_TITLE = 'Leistung';
export const LEISTUNG_ABRECHNUNGEN_PATH = 'abrechnungen';
export const LEISTUNG_ABRECHNUNGEN_TITLE = 'Abrechnungen';
export const LEISTUNG_DEF_PATH = 'leistungdef';
export const LEISTUNG_DEF_TITLE = 'Leistung Definitionen';
export const LEISTUNG_IMPORTER_PATH = 'leistungimport';
export const LEISTUNG_IMPORTER_TITLE = 'Leistungdefinition Import';
export const USER_PATH = 'user';
export const USER_LIST_PATH = 'users';
export const USER_LIST_TITLE = 'Users';

export const KIDS_PATH = 'kids';
export const KIDS_TITLE = 'Potentielle Kandidaten';
export const KIDS_TERMINE_PATH = 'kidstermine';
export const KIDS_TERMINE_TITLE = 'Kids Termine';
export const KIDS_TERMIN_PATH = 'kidstermin';
export const KIDS_BUCHUNG_PATH = 'kidsreservierung';
export const KIDS_HOTELS_PATH = 'kidshotels';
export const KIDS_HOTELS_TITLE = 'Kids Hotels';
export const KIDS_IMPORT_PATH = 'kidsimport';
export const KIDS_IMPORT_TITLE = 'Kids Import';
